/**
 * Live Sources Store
 *
 * The LIVE MAP's own selected source IDs (its map-settings boat toggles), published so the
 * map-scoped consumers — playbackStore's live data-edge clock and RealtimeDataTable — follow the
 * same boats the map draws. Written by LiveMap.tsx and persisted under the `liveMapSources` user
 * setting by utils/liveSourcePersistence.
 *
 * NOT the shared source selection. The report pages (including the live ones) filter by
 * filterStore.selectedSources / fleetPerformanceSources instead, so choosing which boats to watch
 * on the live map no longer re-selects them everywhere else.
 */

import { createRoot, createSignal, Accessor } from 'solid-js';
import { debug as logDebug } from '../utils/console';

interface LiveSourcesStore {
  /** Selected source IDs (from map settings toggles) */
  selectedSourceIds: Accessor<Set<number>>;
  /** Set selected source IDs */
  setSelectedSourceIds: (ids: Set<number>) => void;
  /** Clear selection (e.g. when leaving live mode) */
  clear: () => void;
}

export const liveSourcesStore = createRoot<LiveSourcesStore>(() => {
  const [selectedSourceIds, setSelectedSourceIds] = createSignal<Set<number>>(new Set());

  const setIds = (ids: Set<number>) => {
    setSelectedSourceIds(new Set(ids));
    logDebug('[LiveSourcesStore] Updated selected sources', {
      count: ids.size,
      ids: Array.from(ids)
    });
  };

  const clear = () => {
    setSelectedSourceIds(new Set());
    logDebug('[LiveSourcesStore] Cleared selected sources');
  };

  return {
    selectedSourceIds,
    setSelectedSourceIds: setIds,
    clear
  };
});
